import { useState } from "react";
import { contactFields, validateContactField } from "./contactValidation";

export default function ContactForm({ t, c }) {
  const [errors, setErrors] = useState({});
  const [attempted, setAttempted] = useState(false);
  const validate = (field, input) => {
    const error = validateContactField(field, input.value);
    return (
      error ||
      (field.type === "email" && input.validity.typeMismatch ? "email" : null)
    );
  };
  const updateError = (field, input) => {
    const error = validate(field, input);
    setErrors((previous) => ({ ...previous, [field.key]: error }));
  };
  const submit = (event) => {
    const form = event.currentTarget;
    const nextErrors = {};
    let firstInvalid;
    contactFields.forEach((field) => {
      const input = form.elements.namedItem(`entry.${field.id}`);
      nextErrors[field.key] = validate(field, input);
      if (nextErrors[field.key] && !firstInvalid) firstInvalid = input;
    });
    setErrors(nextErrors);
    setAttempted(true);
    if (firstInvalid) {
      event.preventDefault();
      firstInvalid.focus();
    } else {
      // Keep the existing native POST and Google's response; never claim delivery here.
      contactFields.forEach((field) => {
        const input = form.elements.namedItem(`entry.${field.id}`);
        input.value = input.value.trim();
      });
    }
  };
  return (
    <form
      className="contact-form"
      aria-label={c.contactTitle}
      action="https://docs.google.com/forms/d/e/1FAIpQLSccxIpDlVzeLarR-1IcYDGXVk8O1MkqxC_m3zcB1bC0wXFb2A/formResponse"
      method="POST"
      target="_blank"
      rel="noopener noreferrer"
      noValidate
      onSubmit={submit}
    >
      {attempted && Object.values(errors).some(Boolean) && (
        <p className="form-error-summary" role="alert">
          {c.validation.summary}
        </p>
      )}
      <div className="form-grid">
        {contactFields.map((field, index) => {
          const inputId = `contact-${field.key}`;
          const error = errors[field.key];
          const props = {
            id: inputId,
            name: `entry.${field.id}`,
            required: field.required,
            maxLength: field.maxLength,
            "aria-invalid": error ? true : undefined,
            "aria-describedby": error
              ? `${inputId}-error`
              : field.key === "message"
                ? "contact-message-hint"
                : undefined,
            onChange: (event) => {
              if (error || attempted) updateError(field, event.currentTarget);
            },
          };
          return (
            <div
              className={`form-field ${field.key === "message" ? "form-wide" : ""}`}
              key={field.id}
            >
              <label htmlFor={inputId}>
                {t.googleform[index].replace("*", "")}
                {field.required ? " *" : ""}
              </label>
              {field.key === "message" ? (
                <textarea {...props} rows="3" />
              ) : (
                <input
                  {...props}
                  type={field.type || "text"}
                  autoComplete={field.autoComplete}
                />
              )}
              {error && (
                <p className="field-error" id={`${inputId}-error`}>
                  {c.validation[error].replace("{max}", field.maxLength)}
                </p>
              )}
              {field.key === "message" && (
                <p className="field-hint" id="contact-message-hint">
                  {c.validation.hint}
                </p>
              )}
            </div>
          );
        })}
      </div>
      <div className="form-bottom">
        <p>{c.formNote}</p>
        <button className="button" type="submit">
          {c.send}
          <span aria-hidden="true">↗</span>
        </button>
      </div>
    </form>
  );
}
